import {
  Mic,
  MicOff,
  MonitorUp,
  PhoneOff,
  Settings,
  Video,
  VideoOff,
} from "lucide-react";
import type { MediaState } from "../types";

interface Props {
  mediaState: MediaState;
  onToggleMic: () => void;
  onToggleCamera: () => void;
  onToggleScreen: () => void;
  onOpenSettings: () => void;
  onLeave: () => void;
  /** Organizer extra: end for everyone. */
  onEndForAll?: (() => void) | null;
}

const BTN =
  "flex h-11 w-11 items-center justify-center rounded-full border transition-colors";

export function MeetingControls({
  mediaState,
  onToggleMic,
  onToggleCamera,
  onToggleScreen,
  onOpenSettings,
  onLeave,
  onEndForAll = null,
}: Props) {
  return (
    <div className="flex items-center justify-center gap-3 border-t border-[var(--color-border)] bg-[var(--color-bg-surface)] px-4 py-3">
      <button
        type="button"
        onClick={onToggleMic}
        title={mediaState.audio ? "Wycisz mikrofon" : "Włącz mikrofon"}
        className={`${BTN} ${
          mediaState.audio
            ? "border-[var(--color-border)] text-[var(--color-text-primary)] hover:bg-black/5 dark:hover:bg-white/10"
            : "border-red-600 bg-red-600 text-white"
        }`}
      >
        {mediaState.audio ? <Mic size={18} /> : <MicOff size={18} />}
      </button>
      <button
        type="button"
        onClick={onToggleCamera}
        title={mediaState.video ? "Wyłącz kamerę" : "Włącz kamerę"}
        className={`${BTN} ${
          mediaState.video
            ? "border-[var(--color-border)] text-[var(--color-text-primary)] hover:bg-black/5 dark:hover:bg-white/10"
            : "border-red-600 bg-red-600 text-white"
        }`}
      >
        {mediaState.video ? <Video size={18} /> : <VideoOff size={18} />}
      </button>
      <button
        type="button"
        onClick={onToggleScreen}
        title={mediaState.screen ? "Zatrzymaj udostępnianie ekranu" : "Udostępnij ekran"}
        className={`${BTN} ${
          mediaState.screen
            ? "border-[var(--color-primary)] bg-[var(--color-primary)] text-white"
            : "border-[var(--color-border)] text-[var(--color-text-primary)] hover:bg-black/5 dark:hover:bg-white/10"
        }`}
      >
        <MonitorUp size={18} />
      </button>
      <button
        type="button"
        onClick={onOpenSettings}
        title="Urządzenia (kamera / mikrofon / głośnik)"
        className={`${BTN} border-[var(--color-border)] text-[var(--color-text-primary)] hover:bg-black/5 dark:hover:bg-white/10`}
      >
        <Settings size={18} />
      </button>
      <button
        type="button"
        onClick={onLeave}
        title="Opuść spotkanie"
        className={`${BTN} border-red-600 bg-red-600 text-white hover:bg-red-700`}
      >
        <PhoneOff size={18} />
      </button>
      {onEndForAll && (
        <button
          type="button"
          onClick={onEndForAll}
          className="ml-2 rounded-md border border-red-600 px-3 py-2 text-xs font-medium text-red-600 hover:bg-red-600 hover:text-white"
        >
          Zakończ dla wszystkich
        </button>
      )}
    </div>
  );
}
